// extracted by mini-css-extract-plugin
export default {"editHeader":"irnor jI_9X","editHeaderButtons":"NkXs_","editHeaderButton":"kFXPi","saveButton":"zwBqi kFXPi","cancelButton":"yEFbF kFXPi"};